export default {
  close_account: [],
}